import React, { useEffect } from "react";
import LogoEbco from "../../assets/images/ebconb312x109.png";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../App";
import { useHistory } from "react-router-dom";
import AccessTimeTwoToneIcon from "@material-ui/icons/AccessTimeTwoTone";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100vw",
    justifyContent: "space-between",
    height: "10vh",

    alignItems: "center",
    backgroundColor: "lightBlue",
    padding: "2.6rem",
    position: "fixed",
  },
  image_ebco: {
    marginLeft: "5vw",
    height: "5vh",
    marginTop: "10px",
  },
  detail: {
    backgroundColor: "transparent",
  },
  operator: {
    display: "flex",
    "justify-content": "flex-end",
    /*        'text-shadow': '2px 2px 8px #003366',*/
    color: "black",
    fontWeight: "bold",
    fontSize: "2vh",
  },
  headerdesc: {
    color: "#252d68",
    display: "flex",
    fontSize: "5vh",
    fontWeight: "bold",
    paddingTop: "10px",
    padding: "6px",
    borderRadius: "10px",
  },
  menuOpcoes: {
    display: "flex",
    "justify-content": "flex-end",
    "vertical-align": "text-bottom",
  },
  tempoRestante: {
    display: "flex",
    "justify-content": "flex-end",
    fontSize: "2vh",
    fontWeight: "bold",
  },
  tempoRestanteValor: {
    fontSize: "2vh",
    fontWeight: "bold",
  },
  tempoLimite: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    lineHeight: "10px",
    alignContent: "center",
  },
  justifyContentEnd: {
    justifyContent: "end",
    border: "1px solid green",
  },
}));

export default function Cabecalho(props) {
  const classes = useStyles();
  const { state: authState, dispatch } = React.useContext(AuthContext);
  let history = useHistory();

  const CountDownTimer = (props) => {
    const [expiresIn, setExpiresIn] = React.useState("");
    var MS_PER_MINUTE = 60000;
    let dtInicial = new Date(props.startSession);
    let dtFinal = new Date(
      dtInicial.getTime() + props.expiresIn * MS_PER_MINUTE
    );
    let timeFinal = Math.abs(dtFinal.getTime() - dtInicial.getTime());

    const calcularMinutos = () => {
      let dtAtual = new Date();
      let timeAtual = Math.abs(dtAtual.getTime() - dtInicial.getTime());
      var diffMinutesFinal = Math.ceil(timeFinal / (1000 * 60));
      var diffMinutesAtual = Math.ceil(timeAtual / (1000 * 60));
      let minutos = Number(diffMinutesFinal - diffMinutesAtual) + 1;
      return minutos;
    };

    function padLeadingZeros(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    }

    useEffect(() => {
      setInterval(() => {
        let minutos = calcularMinutos();
        var h = Math.floor(minutos / 60);
        var m = Math.floor(minutos - h * 60);

        setExpiresIn(padLeadingZeros(h, 2) + ":" + padLeadingZeros(m, 2));
        if (minutos < 1) {
          console.log("Logout ");
          dispatch({ type: "LOGOUT" });
          history.push("/");
        }
      }, 1000 * 60);
      let minutos = calcularMinutos();
      var h = Math.floor(minutos / 60);
      var m = Math.floor(minutos - h * 60);
      setExpiresIn(padLeadingZeros(h, 2) + ":" + padLeadingZeros(m, 2));
    }, []);

    return (
      <div className="App">
        <div className={classes.tempoLimite}>
          <AccessTimeTwoToneIcon />
          <span className={classes.tempoRestante}>Resta:</span>
          <span className={classes.tempoRestanteValor}>{expiresIn}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <div>
        <img className={classes.image_ebco} src={LogoEbco} alt="" />
      </div>

      <span className={classes.headerdesc}>
        {props.HeaderDesc.toUpperCase()}{" "}
      </span>

      <div>
        <div className={classes.operator}>Operador: {props.name}</div>
        <div className={classes.tempoRestante}>
          <CountDownTimer
            startSession={authState.startSession}
            expiresIn={authState.expiresIn}
          />
        </div>
      </div>
    </div>
  );
}
